import { Component, OnInit, ViewChild } from '@angular/core';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import { GeneralService } from '../services/general.service';
import { ActivatedRoute } from '@angular/router';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { AvtDialogDeleteComponent } from '../avt-dialog-delete/avt-dialog-delete.component';
import * as globalUrls from '../services/globalVariables';

@Component({
  selector: 'app-avt-param',
  templateUrl: './avt-param.component.html',
  styleUrls: ['./avt-param.component.scss'],
})
export class AvtParamComponent implements OnInit {
  constructor(
    public generalService: GeneralService,
    public route: ActivatedRoute
  ) {}
  data;
  nomEcran: string = 'Paramétre';
  param_code: string = '';
  //col01 type collaborateur
  //mPai01 Mode de paiement
  //tva01 TVA
  //mFac01 Mode Facturation
  //dReg01 Délai règlement
  disabledBtnAjouter: boolean = false;
  showGroupe: boolean = false;
  showGroupe1: boolean = false;
  showGroupe2: boolean = false;
  showGroupe3: boolean = false;
  showGroupe4: boolean = false;
  showLibelle: boolean = false;
  showLibelle1: boolean = true;
  listeGroupeIsLoadet: boolean = false;
  listeGroupe1IsLoadet: boolean = false;
  listeGroupe2IsLoadet: boolean = false;
  listeGroupe3IsLoadet: boolean = false;
  listeGroupe4IsLoadet: boolean = false;
  listeGroupe = [];
  listeGroupe1 = [];
  listeGroupe2 = [];
  listeGroupe3 = [];
  listeGroupe4 = [];
  listeGroupeAll = [];
  listeGroupe1All = [];
  listeGroupe2All = [];
  listeGroupe3All = [];
  listeGroupe4All = [];
  listBtn: Array<any> = [
    {
      name: 'enregistrer',
      class: 'colorGreen',
      text: 'Enregistrer',
      disabled: false,
      icon: 'save',
    },
    {
      name: 'supprimer',
      class: 'colorRed',
      text: 'Supprimer',
      disabled: false,
      icon: 'delete',
    },
  ];
  datasource;
  Columns = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'DiverSys_Index',
        Lg_Code: '',
        TableRD_Des: 'Code',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: 'dd-MM-yyyy',
        TableRD_Alligement: 0,
        TableRD_Ordre: 1,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'DiverSys_Titre',
        Lg_Code: '',
        TableRD_Des: 'Libelle',
        TableRD_Largeur: 200,
        TableRD_ReadOnly: false,
        TableRD_Format: null,
        TableRD_Alligement: 0,
        TableRD_Ordre: 2,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };
  attributValueGroupeSelect: string = '';
  attributTextGroupeSelect: string = '';
  attributValueGroupe1Select: string = '';
  attributTextGroupe1Select: string = '';
  attributValueGroupe2Select: string = '';
  attributTextGroupe2Select: string = '';
  attributValueGroupe3Select: string = '';
  attributTextGroupe4Select: string = '';
  attributValueGroupe4Select: string = '';
  attributTextGroupe3Select: string = '';
  attributValueLibelleSelect: string = '';
  attributTextLibelleSelect: string = '';
  //{text:"Intervenant extérieur (Prestataire)",value:"0"},{text:"Intervenant intérieur",value:"1"}
  listeLibelle = [];
  listeLibelleAll = [];
  @ViewChild(AvtListesComponent, { static: false })
  listeComponen: AvtListesComponent;

  exist = true;
  listeEcran = this.generalService.sort(this.generalService.listeEcran, 'text');
  // ordinaireEcran : boolean = true;
  // showContrat : boolean = false;
  // showAction : boolean = false;
  // showCompte : boolean = false;
  // showHeure : boolean = false;

  //liste type collaborateur : collaboretur, salarier, Formateur...
  ngOnInit() {
    this.data = {};
  }
  onGroupeChange(value) {
    var ecran = this.listeEcran.find((e) => {
      return e.value == this.param_code;
    });
    if (this.generalService.isNotEmpty(ecran.libelle)) {
      this.showLibelle = true;
      switch (ecran.libelle) {
        case 'TYPECONTRATCOLLABORATEUR':
          this.setParamLibelleDiverSis(
            'COL04',
            'DiverSys_Index',
            'DiverSys_Titre'
          );
          break;
      }
    }
  }
  onEcranChange() {
    var ecran = this.listeEcran.find((e) => {
      return e.value == this.param_code;
    });
    this.exist = false;
    this.showGroupe = false;
    this.showGroupe1 = false;
    this.showGroupe2 = false;
    this.showGroupe3 = false;
    this.showGroupe4 = false;
    this.showLibelle = false;
    this.showLibelle1 = true;
    this.listeGroupe = [];
    this.listeGroupe1 = [];
    this.listeLibelle = [];
    // COL03: Status,              COL08: Type rémunération,    COL04: Type contrat collaborateur
    if (
      ecran.value == 'COL03' ||
      ecran.value == 'COL08' ||
      ecran.value == 'COL04'
    ) {
      this.setParamGroupeDiverSis(
        '',
        'COL01',
        'DiverSys_Index',
        'DiverSys_Titre',
        '',
        '',
        false
      );
    }
    // COL05: Temps collaborateur
    else if (ecran.value == 'COL05') {
      this.showLibelle = true;
      this.setParamGroupeDiverSis(
        '',
        'COL01',
        'DiverSys_Index',
        'DiverSys_Titre',
        'DiverSys_Index',
        'DiverSys_Titre',
        false
      );
    }
    // Type contrat apprenant
    else if (ecran.value == 'COL10') {
      this.setParamGroupeDiverSis(
        '',
        'COL07',
        'DiverSys_Index',
        'DiverSys_Titre',
        '',
        '',
        false
      );
    }
    // Type contrat apprenant
    else if (ecran.value == 'RESERV02') {
      this.setParamGroupeDiverSis(
        '',
        'RESERV01',
        'DiverSys_Index',
        'DiverSys_Titre',
        '',
        '',
        false
      );
    }
    // Type de salle (sale/atelier)
    else if (ecran.value == 'SALL01') {
      this.setParamGroupe(
        '',
        'value',
        'text',
        this.generalService.listeMachine_Type,
        false
      );
    }
    //groupe Type de PRESENCE
    else if (ecran.value == 'ACTION01') {
      this.showLibelle1 = false;
      this.setParamGroupeDiverSis(
        '',
        'COL12',
        'DiverSys_Index',
        'DiverSys_Titre',
        '',
        '',
        true
      );
      // this.setParamGroupe("1","value","text",this.generalService.facturableOrNotListe,true);
      // this.setParamGroupe("2","value","text",this.generalService.planifiableOrNotListe,true);
      // this.setParamGroupe("3","value","text",this.generalService.InclusDansCoursOrNotListe,true);
      this.setParamGroupeDiverSis(
        '1',
        'ACTION02',
        'DiverSys_Index',
        'DiverSys_Titre',
        '',
        '',
        true
      );
    }
    // Type de PRESENCE
    else if (ecran.value == 'ACTION02') {
      this.setParamGroupe(
        '1',
        'value',
        'text',
        this.generalService.facturableOrNotListe,
        true
      );
      this.setParamGroupe(
        '2',
        'value',
        'text',
        this.generalService.planifiableOrNotListe,
        true
      );
      this.setParamGroupe(
        '3',
        'value',
        'text',
        this.generalService.InclusDansCoursOrNotListe,
        true
      );
    } else {
      this.listeComponen.setColonne(this.Columns);
      this.getData(false);
    }
    this.data = {};
  }

  setParamLibelleDiverSis(param, attributValue, attributText) {
    this.showLibelle = true;
    this.attributValueLibelleSelect = attributValue;
    this.attributTextLibelleSelect = attributText;
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=' + param)
      .subscribe((data) => {
        this.listeLibelle = data.DiverSys.filter((d) => {
          return d.DiverSys_Group == this.data.DiverSys_Group;
        });
        for (let i = 0; i < this.listeLibelle.length; i++) {
          this.listeLibelle[i].DiverSys_Index =
            this.listeLibelle[i].DiverSys_Index.toString();
        }
      });
  }
  //pour deffinire la liste groupe dans DiverSys
  setParamGroupeDiverSis(
    index,
    param,
    attributGroupeValue,
    attributGroupeText,
    attributLibelleValue,
    attributLibelleText,
    addEmptyRow: boolean
  ) {
    eval('this.listeGroupe' + index + 'IsLoadet = false;');
    eval('this.showGroupe' + index + ' = true;');
    eval('this.attributValueGroupe' + index + 'Select = attributGroupeValue');
    eval('this.attributTextGroupe' + index + 'Select = attributGroupeText');
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=' + param)
      .subscribe((data) => {
        if (addEmptyRow)
          data.DiverSys.push({
            DiverSys_Id: null,
            DiverSys_Type: null,
            DiverSys_Index: '',
            DiverSys_Titre: '',
            DiverSys_Libelle: null,
            DiverSys_Ordre: null,
            DiverSys_Group5: null,
            DiverSys_Group4: null,
            DiverSys_Group3: null,
            DiverSys_Group2: null,
            DiverSys_Group1: null,
            DiverSys_Group: null,
            DiverSys_Ecran: null,
            U_timestamp: null,
          });
        eval('this.listeGroupe' + index + 'All = data.DiverSys;');
        eval('this.listeGroupe' + index + ' = data.DiverSys;');
        var groupe;
        eval('groupe = this.listeGroupe' + index + '.length');
        for (let i = 0; i < groupe; i++) {
          eval(
            'this.listeGroupe' +
              index +
              '[i].DiverSys_Index = this.listeGroupe' +
              index +
              '[i].DiverSys_Index.toString();'
          );
        }
        eval('this.listeGroupe' + index + 'IsLoadet = true');
        this.setListeComponen(
          attributGroupeValue,
          attributGroupeText,
          attributLibelleValue,
          attributLibelleText
        );
      });
  }
  setParamGroupe(
    index,
    attributGroupeValue,
    attributGroupeText,
    liste,
    addEmptyRow: boolean
  ) {
    eval('this.listeGroupe' + index + 'IsLoadet = false;');
    eval('this.showGroupe' + index + ' = true;');
    eval('this.attributValueGroupe' + index + 'Select = attributGroupeValue ;');
    eval('this.attributTextGroupe' + index + 'Select = attributGroupeText;');
    var lst = this.generalService.clone(liste);
    if (addEmptyRow)
      eval(
        "lst.push({'" +
          attributGroupeValue +
          "' : '', '" +
          attributGroupeText +
          "' : ''})"
      );

    for (let i = 0; i < liste.length; i++) {
      eval(
        'lst[i].' +
          attributGroupeValue +
          ' = lst[i].' +
          attributGroupeValue +
          '.toString();'
      );
    }
    eval('this.listeGroupe' + index + ' = lst;');
    eval('this.listeGroupe' + index + 'IsLoadet = true');
    this.setListeComponen(attributGroupeValue, attributGroupeText, '', '');
  }
  setListeComponen(
    attributGroupeValue,
    attributGroupeText,
    attributLibelleValue,
    attributLibelleText
  ) {
    var columns = this.generalService.clone(this.Columns);
    var ecran = this.listeEcran.find((e) => {
      return e.value == this.param_code;
    });

    // groupe Type de PRESENCE
    if (ecran.value == 'ACTION01') {
      columns.TableRD = columns.TableRD.filter((colo) => {
        return colo.TableRD_Champs != 'DiverSys_Titre';
      });
      columns.TableRD.push({
        TableRE_Code: '',
        TableRD_Champs: 'DiverSys_Group1',
        Lg_Code: '',
        TableRD_Des: 'Condition',
        TableRD_Largeur: 300,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 5,
        TableRD_Type: 2,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        dataSelect: this.listeGroupe1,
        valueSelect: attributGroupeValue,
        textSelect: attributGroupeText,
      }); //,
    }
    // Type de PRESENCE
    if (ecran.value == 'ACTION02') {
      columns.TableRD.push({
        TableRE_Code: '',
        TableRD_Champs: 'DiverSys_Group1',
        Lg_Code: '',
        TableRD_Des: 'Condition',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 5,
        TableRD_Type: 2,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        dataSelect: this.listeGroupe1,
        valueSelect: 'value',
        textSelect: 'text',
      });
      columns.TableRD.push({
        TableRE_Code: '',
        TableRD_Champs: 'DiverSys_Group2',
        Lg_Code: '',
        TableRD_Des: 'Condition',
        TableRD_Largeur: 150,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 7,
        TableRD_Type: 2,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        dataSelect: this.listeGroupe2,
        valueSelect: 'value',
        textSelect: 'text',
      });
      columns.TableRD.push({
        TableRE_Code: '',
        TableRD_Champs: 'DiverSys_Group3',
        Lg_Code: '',
        TableRD_Des: 'Condition',
        TableRD_Largeur: 200,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 9,
        TableRD_Type: 2,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        dataSelect: this.listeGroupe3,
        valueSelect: 'value',
        textSelect: 'text',
      });
    } else
      columns.TableRD.push({
        TableRE_Code: '',
        TableRD_Champs: 'DiverSys_Group',
        Lg_Code: '',
        TableRD_Des: 'Groupe',
        TableRD_Largeur: 300,
        TableRD_ReadOnly: false,
        TableRD_Format: null,
        TableRD_Alligement: 0,
        TableRD_Ordre: 3,
        TableRD_Type: 2,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        dataSelect: this.listeGroupe,
        valueSelect: attributGroupeValue,
        textSelect: attributGroupeText,
      });
    //ecran Temps collaborateur
    if (ecran.value == 'COL05') {
      this.generalService
        .rechercheTable(globalUrls.urlParametre + '&val=COL04')
        .subscribe((data) => {
          for (let i = 0; i < data.DiverSys.length; i++) {
            data.DiverSys[i].DiverSys_Index =
              data.DiverSys[i].DiverSys_Index.toString();
          }
          this.listeLibelleAll = data.DiverSys;
          this.generalService
            .rechercheTable(globalUrls.urlParametre + '&val=' + this.param_code)
            .subscribe((data2) => {
              var listeTempCollaborateur = [];
              data2.DiverSys.forEach((d2) => {
                //data.DiverSys.filter(d => {return d.DiverSys_Group == this.data.DiverSys_Group});
                listeTempCollaborateur.push(
                  data.DiverSys.filter((filterData) => {
                    return filterData.DiverSys_Group == d2.DiverSys_Group;
                  })
                );
              });
              columns.TableRD.push({
                TableRE_Code: '',
                TableRD_Champs: 'DiverSys_Libelle',
                Lg_Code: '',
                TableRD_Des: 'Type',
                TableRD_Largeur: 300,
                TableRD_ReadOnly: false,
                TableRD_Format: null,
                TableRD_Alligement: 0,
                TableRD_Ordre: 3,
                TableRD_Type: 104,
                TableRD_Param1: null,
                TableRD_Param2: null,
                TableRD_ValDef: null,
                TableRD_Tri: true,
                TableRD_Valid: null,
                TableRD_ValidType: 0,
                TableRD_ExpressionH: null,
                TableRD_ExpressionR: null,
                User_Id: '*',
                User_Groupe: null,
                dataSelect: listeTempCollaborateur,
                valueSelect: attributLibelleValue,
                textSelect: attributLibelleText,
              });
              this.listeComponen.setColonne(columns);
              this.datasource = data2;
              if (
                !this.generalService.isNotEmpty(
                  data2.DiverSys[0].DiverSys_Index
                ) &&
                data2.DiverSys.length == 1
              )
                this.listeComponen.setDataSource([]);
              else this.listeComponen.setDataSource(data2.DiverSys);
              this.exist = true;
            });
        });
    } else {
      this.listeComponen.setColonne(columns);
      this.getData(false);
    }
  }
  init() {}
  getData(showMsgEnregistrer: boolean) {
    this.exist = false;
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=' + this.param_code)
      .subscribe((data) => {
        this.datasource = data;
        this.setCode();
        if (
          !this.generalService.isNotEmpty(data.DiverSys[0].DiverSys_Index) &&
          data.DiverSys.length == 1
        )
          this.listeComponen.setDataSource([]);
        else this.listeComponen.setDataSource(data.DiverSys);
        if (showMsgEnregistrer)
          this.generalService.dialogSuccess('enregistré', true);
        this.exist = true;
      });
  }
  ajouter(form) {
    if (form.form.valid) {
      if (!this.existRow()) {
        this.disabledBtnAjouter = true;
        this.exist = false;
        this.generalService.rechercheTable(globalUrls.urlParametre).subscribe(
          (data) => {
            data.DiverSys[0].DiverSys_Type = this.param_code;
            data.DiverSys[0].DiverSys_Index = this.data.DiverSys_Index;
            if (this.generalService.isNotEmpty(this.data.DiverSys_Titre))
              data.DiverSys[0].DiverSys_Titre = this.data.DiverSys_Titre;
            else data.DiverSys[0].DiverSys_Titre = '';
            if (this.generalService.isNotEmpty(this.data.DiverSys_Group))
              data.DiverSys[0].DiverSys_Group = this.data.DiverSys_Group;
            if (this.generalService.isNotEmpty(this.data.DiverSys_Libelle))
              data.DiverSys[0].DiverSys_Libelle = this.data.DiverSys_Libelle;

            if (this.generalService.isNotEmpty(this.data.DiverSys_Group1))
              data.DiverSys[0].DiverSys_Group1 = this.data.DiverSys_Group1;
            if (this.generalService.isNotEmpty(this.data.DiverSys_Group2))
              data.DiverSys[0].DiverSys_Group2 = this.data.DiverSys_Group2;
            if (this.generalService.isNotEmpty(this.data.DiverSys_Group3))
              data.DiverSys[0].DiverSys_Group3 = this.data.DiverSys_Group3;
            if (this.generalService.isNotEmpty(this.data.DiverSys_Group4))
              data.DiverSys[0].DiverSys_Group4 = this.data.DiverSys_Group4;
            this.generalService.enregisterTable(data).subscribe(
              (saveData) => {
                this.disabledBtnAjouter = false;
                this.onEcranChange();
                this.generalService.dialogSuccess('enregistré', true);
              },
              (err) => {
                this.exist = true;
                this.disabledBtnAjouter = false;
                this.generalService.dialogSuccess('Non enregistré', false);
              }
            );
          },
          (err) => {
            this.exist = true;
            this.disabledBtnAjouter = false;
          }
        );
      } else
        this.generalService.dialogSuccess(
          'cet enregistrement existe déjà',
          false
        );
    }
  }
  setCode() {
    var persoContrat_Code: number = parseInt(
      this.datasource.DiverSys.reduce(
        (max, code) =>
          parseInt(code.DiverSys_Index) > max
            ? parseInt(code.DiverSys_Index)
            : max,
        parseInt(this.datasource.DiverSys[0].DiverSys_Index)
      )
    );
    if (typeof persoContrat_Code == 'number' && persoContrat_Code >= 0)
      this.data.DiverSys_Index = persoContrat_Code + 1;
    else this.data.DiverSys_Index = 1;
  }
  existRow(): boolean {
    var find = this.datasource.DiverSys.find((row) => {
      return (
        row.DiverSys_Index == this.data.DiverSys_Index ||
        (row.DiverSys_Titre == this.data.DiverSys_Titre &&
          row.DiverSys_Group == this.data.DiverSys_Group)
      );
    });
    if (find == undefined) return false;
    else return true;
  }
  modifier() {
    this.exist = false;
    this.listBtn[0].disabled = true;
    this.generalService.enregisterTable(this.datasource).subscribe(
      (data) => {
        this.listBtn[0].disabled = false;
        this.generalService.dialogSuccess('Enregistré', true);
        this.onEcranChange();
      },
      (err) => {
        this.generalService.dialogSuccess('Non enregister', false);
        this.exist = true;
        this.listBtn[0].disabled = false;
      }
    );
  }
  clickBtnHeat(event) {
    switch (event.name) {
      case 'enregistrer': {
        this.modifier();
        break;
      }
      case 'supprimer': {
        this.supprimer(event.row);
        break;
      }
      case 'selectRow': {
        this.selectRow(event);
        break;
      }
      case 'btnclearGroup': {
        this.clearChamp(event, '');
        break;
      }
      case 'btnclearGroup1': {
        this.clearChamp(event, '1');
        break;
      }
      case 'btnclearGroup2': {
        this.clearChamp(event, '2');
        break;
      }
      case 'btnclearGroup3': {
        this.clearChamp(event, '3');
        break;
      }
    }
  }
  clearChamp(event, index) {
    eval('event.row.DiverSys_Group' + index + ' = ""');
  }
  selectRow(event) {
    // var DiverSys_Group = event.row["DiverSys_Group"]
    // this.listeComponen.displayedColumnsBrut.TableRD[3].dataSelect = this.listeLibelleAll.filter(libelle =>{return libelle.DiverSys_Group == DiverSys_Group});
    // this.listeComponen.setDataSource(this.listeComponen.dataSource.data)
  }
  supprimer(row) {
    const dialogConfig = this.generalService.dialogConfig;
    dialogConfig.autoFocus = true;
    var dialogRef = this.generalService.dialog.open(
      AvtDialogDeleteComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result == 'supprimer') {
        var deleteFn = this.generalService.supprimerSanMsgConfirm(
          row.DiverSys_Id,
          'DiverSysSup'
        );
        if (deleteFn != null) {
          this.exist = false;
          this.listBtn[1].disabled = true;
          deleteFn.subscribe(
            (data) => {
              this.getData(false);
              this.generalService.dialogSuccess('Elément supprimer', true);
              this.exist = true;
              this.listBtn[1].disabled = false;
            },
            (error) => {
              this.generalService.dialogSuccess('Elément non supprimé', false);
              this.exist = true;
              this.listBtn[1].disabled = false;
            }
          );
        }
      }
      if (result == 'annuler') {
      }
    });
  }
  getValueSelect(select, attributSelect) {
    var value;
    var expression = 'value = select.' + attributSelect;
    eval(expression);
    return value;
  }
  // pour l'ecran temps collaboreateur, se declenche apre ke mat-select dans le composon listeComponen change de selection
  selectChange(event) {
    //ecran Temps collaborateur
    if (this.param_code == 'COL05') {
      this.listeComponen.displayedColumnsBrut.TableRD[3].dataSelect[
        event.index
      ] = this.listeLibelleAll.filter((filterData) => {
        return filterData.DiverSys_Group == event.row.DiverSys_Group;
      });
    }
  }
  onTypePersoChange() {
    if (this.listeGroupeIsLoadet) {
      this.listeGroupe = this.listeGroupeAll.filter((listeGroupe) => {
        return listeGroupe.DiverSys_Group == this.data.DiverSys_Ordre;
      });
    }
  }
}
